var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShoppingBasket = function SvgShoppingBasket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.584 17.662 18.25 9.75H5.75l1.666 7.912a2 2 0 0 0 1.957 1.588h5.254a2 2 0 0 0 1.957-1.588ZM8.75 9.5V7.75a3 3 0 0 1 3-3h.5a3 3 0 0 1 3 3V9.5m4 .25H4.75"
  })));
};
export { SvgShoppingBasket as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBzdHJva2U9IiMwMDAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiIGQ9Ik0xNi41ODQgMTcuNjYyIDE4LjI1IDkuNzVINS43NWwxLjY2NiA3LjkxMmEyIDIgMCAwIDAgMS45NTcgMS41ODhoNS4yNTRhMiAyIDAgMCAwIDEuOTU3LTEuNTg4Wk04Ljc1IDkuNVY3Ljc1YTMgMyAwIDAgMSAzLTNoLjVhMyAzIDAgMCAxIDMgM1Y5LjVNMTkuMjUgOS43NUg0Ljc1Ii8+PC9zdmc+";